import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import ar from '../locales/ar.json';
import en from '../locales/en.json';
import tr from '../locales/tr.json';

// Get saved language from localStorage or default to Arabic
const getSavedLanguage = () => {
  try {
    const saved = localStorage.getItem('lang');
    if (saved && ['ar', 'en', 'tr'].includes(saved)) {
      return saved;
    }
  } catch (error) {
    console.warn('Failed to read language from localStorage:', error);
  }
  return 'ar';
};

i18n
  .use(initReactI18next)
  .init({
    resources: {
      ar: {
        translation: ar,
      },
      en: {
        translation: en,
      },
      tr: {
        translation: tr,
      },
    },
    lng: getSavedLanguage(), // Default language
    fallbackLng: 'en', // Fallback language
    interpolation: {
      escapeValue: false, // React already escapes values
    },
    react: {
      useSuspense: false, // Disable suspense for better compatibility
    },
  });

// Listen for language changes and persist to localStorage
i18n.on('languageChanged', (lng) => {
  try {
    localStorage.setItem('lang', lng);
  } catch (error) {
    console.warn('Failed to save language to localStorage:', error);
  }
});

export default i18n;
